import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const scrollPositions = new Map();

export function useScrollRestoration() {
  const location = useLocation();
  const scrollKey = location.pathname + location.search;
  const scrollRef = useRef(null);

  // Восстановить скролл при монтировании
  useEffect(() => {
    const isPlacePage = location.pathname.startsWith('/place/');
    const savedPosition = scrollPositions.get(scrollKey);

    // Для страниц мест всегда скроллим в начало
    if (isPlacePage) {
      window.scrollTo(0, 0);
    } else if (savedPosition !== undefined && scrollRef.current) {
      // Восстанавливаем сохраненную позицию для остальных страниц (включая категории)
      requestAnimationFrame(() => {
        window.scrollTo(0, savedPosition);
      });
    } else {
      // Если нет сохраненной позиции, скроллим в начало
      window.scrollTo(0, 0);
    }

    // Сохранить скролл при размонтировании
    return () => {
      const currentScroll = window.scrollY;

      // Не сохраняем скролл только для страниц мест
      if (!isPlacePage) {
        scrollPositions.set(scrollKey, currentScroll);
      } else {
        // Удаляем сохраненную позицию, если она была
        scrollPositions.delete(scrollKey);
      }
    };
  }, [scrollKey, location.pathname]);

  return scrollRef;
}
